import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onAddNew, hasFilters, onClearFilters }) => {
  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mb-6">
          <Icon name="Search" size={40} className="text-muted-foreground" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">
          No words found
        </h3>
        <p className="text-muted-foreground text-center max-w-md mb-6">
          No glossary entries match your current filters. Try adjusting your search criteria or clearing filters.
        </p>
        <Button variant="outline" onClick={onClearFilters}>
          Clear Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mb-6">
        <Icon name="BookText" size={40} className="text-primary" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">
        No glossary entries yet
      </h3>
      <p className="text-muted-foreground text-center max-w-md mb-6">
        Start building your Shakespeare glossary by adding archaic English words with modern definitions and pronunciation guides.
      </p>
      <Button variant="default" iconName="Plus" iconPosition="left" onClick={onAddNew}>
        Add First Word
      </Button>
    </div>
  );
};

export default EmptyState;